<!-- text box -->
<div class="k-form-field k-form-field-with-icon sam-full-width sam-margin number-bar">
   <fa-icon [icon]="phoneHangUpIcon"></fa-icon>
   <input
      fxFlex="1 1 auto"
      [value]="currentNumber$ | async"
      (input)="dialPadNumberChanged($event.target.value)"
      (focusin)="onNumberInputFocusIn($event.target.value)"
      placeholder="{{ 'brick.brick_definitions.call_control.placeholder' | translate }}"
      kendoTextBox
      #numberInDialpad
   />
   <fa-icon
      [icon]="cancelIcon"
      *ngIf="(currentNumber$ | async)?.length > 0"
      (click)="dialPadNumberChanged('')"
   ></fa-icon>
</div>

<!-- Dialpad -->
<div class="dialpad" fxLayout="column" fxFlex="1 1 auto">
   <div
      class="dial-control-row"
      [class.show-only-control-buttons]="!(showDialpad$ | async)"
      fxLayout="row"
      fxFlex="1 1 20%"
   >
      <button
         class="dial-control dial-control-accept"
         fxFlex="1 1 auto"
         kendoButton
         (click)="acceptOrStartCall()"
         [disabled]="!((isCallRingingAndAcceptable$ | async) || (canPhoneMakeCall$ | async))"
      >
         <div
            samwebAutoFitFontSize
            class="fa-layers"
            [ngClass]="{ 'sam-wiggle': (acceptOrStartCallAction$ | async) === 'accept' }"
         >
            <fa-icon
               [icon]="dialArrowIcon"
               transform="shrink-8 right-4 up-6"
               *ngIf="(acceptOrStartCallAction$ | async) === 'dial'"
            ></fa-icon>
            <fa-icon
               [icon]="userDecisionIcon"
               transform="shrink-8 right-4 up-6"
               *ngIf="(acceptOrStartCallAction$ | async) === 'user-decision'"
            ></fa-icon>
            <fa-icon [icon]="phoneAnswerIcon"></fa-icon>
         </div>
      </button>
      <div fxLayoutAlign="center center" class="assisted-state" *ngIf="(myAssistedStateEnum$ | async).icon !== null">
         <span
            kendoTooltip
            [title]="
               (myAssistedStateEnum$ | async).stateText
                  | translate
                     : {
                          username: ((myAssistedState$ | async)?.assistingUserId | userIdToUserShortInfo$ | async)
                             ?.displayName
                       }
            "
         >
            <fa-icon [icon]="(myAssistedStateEnum$ | async).icon" fxLayoutAlign="center center"> </fa-icon>
         </span>
      </div>
      <button
         class="dial-control dial-control-hang-up"
         fxFlex="1 1 auto"
         kendoButton
         (click)="hangUpPhone()"
         [disabled]="!((isCallInProgress$ | async) || (canDisconnectLineA$ | async))"
      >
         <div samwebAutoFitFontSize class="fa-layers">
            <fa-icon [icon]="phoneHangUpIcon"></fa-icon>
         </div>
      </button>
   </div>

   <div fxLayout="row" fxFlex="1 1 20%" *ngIf="showDialpad$ | async">
      <samweb-dialpad-key fxFlex="1 1 33.33%" key="1" [brickInstanceId]="brickInstanceId"></samweb-dialpad-key>
      <samweb-dialpad-key fxFlex="1 1 33.33%" key="2" [brickInstanceId]="brickInstanceId"></samweb-dialpad-key>
      <samweb-dialpad-key fxFlex="1 1 33.33%" key="3" [brickInstanceId]="brickInstanceId"></samweb-dialpad-key>
   </div>
   <div fxLayout="row" fxFlex="1 1 20%" *ngIf="showDialpad$ | async">
      <samweb-dialpad-key fxFlex="1 1 33.33%" key="4" [brickInstanceId]="brickInstanceId"></samweb-dialpad-key>
      <samweb-dialpad-key fxFlex="1 1 33.33%" key="5" [brickInstanceId]="brickInstanceId"></samweb-dialpad-key>
      <samweb-dialpad-key fxFlex="1 1 33.33%" key="6" [brickInstanceId]="brickInstanceId"></samweb-dialpad-key>
   </div>
   <div fxLayout="row" fxFlex="1 1 20%" *ngIf="showDialpad$ | async">
      <samweb-dialpad-key fxFlex="1 1 33.33%" key="7" [brickInstanceId]="brickInstanceId"></samweb-dialpad-key>
      <samweb-dialpad-key fxFlex="1 1 33.33%" key="8" [brickInstanceId]="brickInstanceId"></samweb-dialpad-key>
      <samweb-dialpad-key fxFlex="1 1 33.33%" key="9" [brickInstanceId]="brickInstanceId"></samweb-dialpad-key>
   </div>
   <div fxLayout="row" fxFlex="1 1 20%" *ngIf="showDialpad$ | async">
      <samweb-dialpad-key fxFlex="1 1 33.33%" key="*" [brickInstanceId]="brickInstanceId"></samweb-dialpad-key>
      <samweb-dialpad-key fxFlex="1 1 33.33%" key="0" [brickInstanceId]="brickInstanceId"></samweb-dialpad-key>
      <samweb-dialpad-key fxFlex="1 1 33.33%" key="#" [brickInstanceId]="brickInstanceId"></samweb-dialpad-key>
   </div>
</div>
